export default __webpack_public_path__ + "static/media/pana.9721db0c.svg";